import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Table, Container } from 'reactstrap';
import { useConditionalDataEffect } from '@bottomless/common/src/hooks';
import { PanelPage } from '../../layouts/PanelPage/PanelPage';
import { IsAuth } from '../../guards/auth.guard';
import { getChargeDetailAction } from '../../store';

const ChargeTypes = {
  order: 'order',
  membership: 'membership',
};

const ChargeDetailPageComponent = ({ getChargeDetail, ...props }) => {
  const { id } = useParams();
  const [charge, setCharge] = useState(null);

  useConditionalDataEffect(!charge, () => getChargeDetail(id), setCharge);

  if (!charge) {
    return (
      <IsAuth {...props}>
        <PanelPage>
          <Container>
            <div className="text-center">Loading...</div>
          </Container>
        </PanelPage>
      </IsAuth>
    );
  }

  return (
    <IsAuth {...props}>
      <PanelPage>
        <Container>
          <div className="mb-4">
            <h3>Invoice #: {charge.id}</h3>
            <div>{new Date(charge.date).toLocaleDateString()}</div>
          </div>

          {charge.address && (
            <div className="mb-4">
              <h5 className="text-capitalize">Billed To</h5>
              <div>{charge.address.name || `${charge.user.first_name} ${charge.user.last_name}`}</div>
              {charge.address.street1 ? (
                <>
                  <div>{charge.address.street1}</div>
                  {charge.address.street2 && <div>{charge.address.street2}</div>}
                  <div>
                    {charge.address.city}, {charge.address.state}, {charge.address.zip}
                  </div>
                </>
              ) : (
                <div>{charge.address.toString()}</div>
              )}
            </div>
          )}

          <div className="mb-4">
            <h4 className="text-capitalize">Purchase Details</h4>
            <Table responsive>
              <thead className="thead-inverse">
                <tr>
                  <th>Product</th>
                  <th>{charge.type === ChargeTypes.membership ? 'Quantity (months)' : 'Quantity'}</th>
                  <th>Unit Cost</th>
                  {charge.type === ChargeTypes.membership ? (
                    charge.taxpaid && <th>Tax</th>
                  ) : (
                    <>
                      {charge.taxpaid && <th>Tax</th>}
                      <th>Shipping Cost</th>
                    </>
                  )}
                  <th>Total Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{charge.name}</td>
                  <td>{charge.quantity}</td>
                  <td>${charge.unitcost}</td>
                  {charge.type === ChargeTypes.membership ? (
                    charge.taxpaid && <td>${charge.taxpaid}</td>
                  ) : (
                    <>
                      {charge.taxpaid && <td>${charge.taxpaid}</td>}
                      <td>${charge.shipmentcost}</td>
                    </>
                  )}
                  <td>${charge.totalcost}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <div className="mt-5 text-muted">
            <div>Bottomless, Inc.</div>
            <div>221 1st Ave W, Suite 510, Seattle, WA 98119</div>
          </div>
        </Container>
      </PanelPage>
    </IsAuth>
  );
};

ChargeDetailPageComponent.propTypes = {
  getChargeDetail: PropTypes.func.isRequired,
};

export const ChargeDetailPage = connect(null, dispatch => ({
  getChargeDetail: id => dispatch(getChargeDetailAction(id)),
}))(ChargeDetailPageComponent);
